import axios from "@configs/axios";
import { useMutation } from "@tanstack/react-query";

export const createCreditCard = ({ data }) => {
  return axios.post(`/api/financial/credit-card/`, data);
};

export const useCreateCreditCard = ({ config } = {}) => {
  return useMutation({
    ...config,
    mutationFn: createCreditCard,
  });
};
